// src/components/modals/InvoiceDetailsModal.tsx

import React from "react";
import { Modal, Descriptions } from "antd";

interface InvoiceDetailsModalProps {
  visible: boolean;
  onClose: () => void;
  invoice: any | null;
}

const InvoiceDetailsModal: React.FC<InvoiceDetailsModalProps> = ({
  visible,
  onClose,
  invoice,
}) => {
  if (!invoice) {return null;}

  return (
    <Modal
      title="Invoice Details"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={600}
    >
      <Descriptions column={1} bordered>
        <Descriptions.Item label="Invoice ID">{invoice.id}</Descriptions.Item>
        <Descriptions.Item label="Customer">
          {invoice.customer}
        </Descriptions.Item>
        <Descriptions.Item label="Plan">{invoice.plan}</Descriptions.Item>
        <Descriptions.Item label="Amount">{invoice.amount}</Descriptions.Item>
        <Descriptions.Item label="Status">{invoice.status}</Descriptions.Item>
        <Descriptions.Item label="Generated On">
          {invoice.date}
        </Descriptions.Item>
        <Descriptions.Item label="Due Date">
          {invoice.dueDate}
        </Descriptions.Item>
        <Descriptions.Item label="Next Billing">
          {invoice.next}
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};

export default InvoiceDetailsModal;
